module.exports = __webpack_public_path__ + "img/9_72.f2cb7bcc.png";